// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Se2n","inner":"Footer_inner__1HKsa","nextIcon":"Footer_nextIcon__3XOUY","innerLeft":"Footer_innerLeft__2vrS1"};